/// <reference path="applicationContext.ts" />
/// <reference path="config.ts" />
/// <reference path="component.ts" />
/// <reference path="detail.ts" />
/// <reference path="docAction.ts" />
/// <reference path="functions.ts" />
/// <reference path="helper.ts" />
/// <reference path="loader.ts" />
/// <reference path="locale.ts" />
/// <reference path="logging.ts" />
/// <reference path="navigation.ts" />
/// <reference path="obhelpers.ts" />
/// <reference path="userSettings.ts" />
/// <reference path="widgets.ts" />
/// <reference path="metadataKeywordEditors.ts" />
/// <reference path="metadataWorkViewEditors.ts" />
/// <reference path="wpt.config.d.ts" />
/// <reference path="wpt.rest.d.ts" />
/// <reference path="../../../oidc-client-1.11/oidc-client.d.ts" />
/// <reference path="../../../chartjs-3.7.1/chartjs.d.ts" />
/// <reference path="../../../google.maps-3.48/google.maps-3.48.d.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Namespace for the Web Portal Toolkit Gateway coding.
 */
var WPTNamespace;
(function (WPTNamespace) {
    WPTNamespace.HIDDEN_CLASS = 'hidden';
    WPTNamespace.MAX_SLEEP_INTERVALLS = 100;
    WPTNamespace.SCROLLBAR_WIDTH = 17;
    const LOG_CATEGORY = "WPT";
    const KEEPALIVE_INTERVAL = 60000;
    const SLEEP_TIME = 50;
    /** Stages of the WPT */
    let WPTStages;
    (function (WPTStages) {
        /** No stage set */
        WPTStages[WPTStages["UNKNOWN"] = 0] = "UNKNOWN";
        /** Initialisation stage */
        WPTStages[WPTStages["INIT"] = 1] = "INIT";
        /** Initialisation finished stage */
        WPTStages[WPTStages["INITDONE"] = 2] = "INITDONE";
        /** Ready for starting the gateway */
        WPTStages[WPTStages["READY"] = 3] = "READY";
    })(WPTStages || (WPTStages = {}));
    /**
     * Modal types of the WPT
     */
    let ModalType;
    (function (ModalType) {
        /** first modal, normally used */
        ModalType[ModalType["FIRST"] = 0] = "FIRST";
        /** second modal, should only be used for modals from the first modal */
        ModalType[ModalType["SECOND"] = 1] = "SECOND";
        /** error modal, used for warnings/errors */
        ModalType[ModalType["ERROR"] = 2] = "ERROR";
    })(ModalType = WPTNamespace.ModalType || (WPTNamespace.ModalType = {}));
    /**
     * Settings for showing a modal.
     */
    class ModalShowConfig {
        /** default settings */
        constructor() {
            /** Decision whether the modal should be cleared after hiding (default: true) */
            this.ClearOnHide = true;
            /** Decision whether the modal could not be closed with click on backdrop or keyboard (default: false) */
            this.NotClosable = false;
            /** Callback after the modal is hidden, if used the modal NEEDS TO BE RETURNED in here, otherwise it's returned automatically */
            this.HiddenCallback = null;
            /** Callback after the modal is hidden */
            this.AdditionalHiddenCallback = null;
            // intended empty constructor
        }
    }
    WPTNamespace.ModalShowConfig = ModalShowConfig;
    /**
     * Main class for the WPT, holding the whole structure.
     */
    class WPTCore {
        constructor() {
            this._currentStage = WPTStages.UNKNOWN;
            this._currentUser = null;
            this._currentUsername = null;
            this._currentUserVariables = [];
            this._serviceCapabilities = [];
            this._currentUserProfile = null;
            this._currentLoginTime = null;
            this._currentConnection = null;
            this._currentConnectionId = null;
            this._version = null;
            this._server = null;
            this._validServer = null;
            this._initModules = [];
            this._initModulesCounter = 0;
            /** holds the query string from URL with keys in lower case */
            this._queryString = null;
            this._keepAliveInterval = null;
            this._keepAliveIntervalId = null;
            this._keepAliveRunning = false;
            this._sleepTime = SLEEP_TIME;
            /** holds the free modals, indexed by type */
            this._freeModals = [];
            /** holds the used modals, indexed by modal session */
            this._usedModals = [];
            this._log = null;
            this.Logging = null;
            /** Generic functions for WPT. */
            this.Functions = null;
            /** Functions to load resources. */
            this.Loader = null;
            /** Functions around configuration. */
            this.Config = null;
            /** Functions around locale/lang handling. */
            this.Locale = null;
            /** Functions around navigation. */
            this.Navigation = null;
            /** Functions around widget management. */
            this.Widgets = null;
            /** Helper functions. */
            this.Helper = null;
            /** OnBase hekper functions */
            this.OBHelper = null;
            /** Application context support object */
            this.Context = null;
            /** Document actions management */
            this.DocumentActions = null;
            /**
             * Requests a free modal and binds it to the modal session.
             * @param modalType the modal type that is requested
             * @param modalSession the session the modal should be bound to
             * @returns if free the newly bound modal, otherwise NULL
             */
            this.requestModal = (modalType, modalSession) => {
                this._log.info("WPTCore.requestModal()");
                // check if requested type is free
                let modal = this._freeModals[ModalType[modalType]];
                if (modal !== null && modal !== undefined) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("registering modal " + ModalType[modalType] + " with modal session: " + modalSession);
                    }
                    // move modal from free to used and return it
                    this._usedModals[modalSession] = modal;
                    this._freeModals[ModalType[modalType]] = null;
                    return modal;
                }
                else {
                    console.error("modal " + ModalType[modalType] + " is already in use");
                    return null;
                }
            };
            /**
             * Gets a used modal bound to the modal session.
             * @param modalSession the session the modal is bound to
             * @returns if bound to the session the modal, otherwise NULL
             */
            this.getModal = (modalSession) => {
                this._log.info("WPTCore.getModal()");
                // check if used modal exists for the session
                let modal = this._usedModals[modalSession];
                if (modal !== null && modal !== undefined) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("getting modal " + ModalType[modal.Type] + " for modal session: " + modalSession);
                    }
                    return modal;
                }
                else {
                    console.error("unknown modal with modal session: " + modalSession);
                }
            };
            /**
             * Returns/frees a used modal bound to the modal session.
             * @param modalSession the session the modal is bound to
             */
            this.returnModal = (modalSession) => {
                this._log.info("WPTCore.returnModal()");
                // check if used modal exists for the session
                let modal = this._usedModals[modalSession];
                if (modal !== null && modal !== undefined) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("returning modal " + ModalType[modal.Type] + " for modal session: " + modalSession);
                    }
                    // move modal from used to free and delete modal session from the used modals
                    this._freeModals[ModalType[modal.Type]] = modal;
                    this._usedModals[modalSession] = null;
                    delete this._usedModals[modalSession];
                }
                else {
                    console.warn("returned unused modal with modal session: " + modalSession);
                }
            };
            /**
             * Shows a modal and deals with the backdrop in order to allow more than one modal.
             * @param modalSession the session the modal is bound to
             * @param showConfig settings for showing the modal (default is new created configuration object with default settings)
             */
            this.showModal = (modalSession, showConfig = new ModalShowConfig()) => {
                this._log.info("WPTCore.showModal()");
                let modal = this.getModal(modalSession);
                if (modal !== null && modal !== undefined) {
                    // Bootstrap supports only one modal, we need to work around this
                    modal.JQ.one('shown.bs.modal', function () {
                        let zIndex = $(this).css('z-index');
                        let calcIndex = parseInt(zIndex, 10) - 10;
                        $('.modal-backdrop').last().css('z-index', calcIndex);
                    });
                    let core = this;
                    modal.JQ.one('hidden.bs.modal', function () {
                        if (core._log.isTraceEnabled()) {
                            core._log.trace("modal is hidden");
                        }
                        if (showConfig.ClearOnHide) {
                            if (core._log.isTraceEnabled()) {
                                core._log.trace("clear modal content");
                            }
                            // clear modal content
                            modal.DIV.innerHTML = '';
                        }
                        if (showConfig.HiddenCallback) {
                            // we have a specific callback, use it
                            showConfig.HiddenCallback();
                        }
                        else {
                            if (showConfig.AdditionalHiddenCallback) {
                                showConfig.AdditionalHiddenCallback();
                            }
                            // by default return modal after hiding
                            core.returnModal(modalSession);
                        }
                    });
                    // since we keep references to the modals, we may need to change the settings
                    let bsModal = modal.JQ.data('bs.modal');
                    let keyboardValue = true; // allow closing of modal by ESC key
                    let backdropValue = true; // allow closing of modal by click on backdrop
                    if (showConfig.NotClosable) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("not closable");
                        }
                        keyboardValue = false; // prevent closing of modal by ESC key
                        backdropValue = 'static'; // prevent closing of modal by click on backdrop
                    }
                    // create the modal options
                    let options = {
                        backdrop: backdropValue,
                        keyboard: keyboardValue
                    };
                    if (typeof bsModal === 'undefined') {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("bs modal not opened yet, open with options");
                        }
                        // modal wasn't opened yet, no special handling needed
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("bs modal already opened, setting options");
                        }
                        // modal was already opened, special handling needed
                        // enforce change of options
                        bsModal.options.backdrop = backdropValue;
                        bsModal.options.keyboard = keyboardValue;
                        // enforce escape handling
                        bsModal.escape();
                    }
                    // show the modal with the options
                    modal.JQ.modal(options);
                }
                else {
                    console.error("unable to show requested modal, no modal bound to modal session: " + modalSession);
                }
            };
            /**
             * Hides a modal.
             * @param modalSession the session the modal is bound to
             */
            this.hideModal = (modalSession) => {
                this._log.info("WPTCore.hideModal()");
                let modal = this.getModal(modalSession);
                if (modal !== null && modal !== undefined) {
                    modal.JQ.modal('hide');
                }
                else {
                    console.error("unable to hide requested modal, no modal bound to modal session: " + modalSession);
                }
            };
            /**
             * Hides and clears a modal.
             * @param modalSession the session the modal is bound to
             */
            this.hideAndClearModal = (modalSession) => {
                this._log.info("WPTCore.hideAndClearModal()");
                let modal = this.getModal(modalSession);
                if (modal !== null && modal !== undefined) {
                    modal.JQ.one('hidden.bs.modal', function () {
                        modal.DIV.innerHTML = '';
                    });
                    modal.JQ.modal('hide');
                }
                else {
                    console.error("unable to hide and clear requested modal, no modal bound to modal session: " + modalSession);
                }
            };
            /**
             * Gets the version of the gateway.
             * @returns the version string from version.json or hardcoded through build
             */
            this.getGatewayVersion = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.getGatewayVersion()");
                }
                else {
                    
                }
                // using _version in order to allow version changes through version.json.
                return this._isVersionSet() ? this._version : "2.4.0.0-20220822_041044";
            };
            /**
             * Gets the current user or NULL.
             * @returns the currently logged in user or NULL
             */
            this.getCurrentUser = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.getCurrentUser()");
                }
                else {
                    
                }
                return this._currentUser;
            };
            /**
             * Gets the current connection or NULL.
             * @returns the current connection or NULL
             */
            this.getCurrentConnection = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.getCurrentConnection()");
                }
                else {
                    
                }
                return this._currentConnection;
            };
            /**
             * Gets the current connection ID or NULL.
             * @returns the current connection ID or NULL
             */
            this.getCurrentConnectionId = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.getCurrentConnectionId()");
                }
                else {
                    
                }
                return this._currentConnectionId;
            };
            /**
             * Gets the current user name or NULL.
             * @returns the current user name or NULL
             */
            this.getCurrentUsername = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.getCurrentUsername()");
                }
                else {
                    
                }
                return this._currentUsername;
            };
            /**
             * Gets the current date/time of the login or NULL.
             * @returns the current date/time of the login or NULL
             */
            this.getLoginTime = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.getLoginTime()");
                }
                else {
                    
                }
                return this._currentLoginTime;
            };
            /**
             * Gets the information if the server is valid or NULL.
             * @returns the information if the server is valid or NULL
             */
            this.getValidServer = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.getValidServer()");
                }
                else {
                    
                }
                return this._validServer;
            };
            /**
             * Determines if an user is currently logged in.
             * @returns 'true' when a user is logged in, otherwise 'false'
             */
            this.isUserLoggedIn = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.isUserLoggedIn()");
                }
                else {
                    
                }
                return this._currentUser != null;
            };
            /**
             * Gets a query string value or 'undefined'.
             * @param key the key for the wanted query string parameter
             * @returns the value of the query string parameter or 'undefined'
             */
            this.getQueryStringValue = (key) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.QueryStringValues()");
                }
                else {
                    
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("looking for query string: " + key);
                }
                else {
                    
                }
                if (this._queryString == null) {
                    this.updateQueryString();
                }
                let value = this._queryString[key.toLowerCase()];
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("returning query string value: " + value);
                }
                else {
                    
                }
                return value;
            };
            /**
             * Updates the internal query string with the values from the URL.
             * Storing the keys in lower case.
             */
            this.updateQueryString = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.updateQueryString()");
                }
                else {
                    
                }
                this._queryString = this.Functions.examineQueryString();
            };
            /**
             * Changes the query string in the URL and updates the internal query string.
             * @param key the key for the query string parameter
             * @param value the value for the query string parameter
             */
            this.changeQueryStringValue = (key, value) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.changeQueryStringValue()");
                }
                else {
                    
                }
                this.Functions.changeQueryString(key, value);
                this.updateQueryString();
            };
            this.removeQueryString = (key) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.removeQueryString()");
                }
                else {
                    
                }
                this.Functions.removeQueryString(key);
                this.updateQueryString();
            };
            /**
             * Sets the value for the server to be used and tests it with a basic ping.
             * @param server the server (URL of the Service Layer) to be used
             */
            this.setServer = (server) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.setServer()");
                }
                else {
                    
                }
                if (server !== this._server) {
                    this._server = server;
                    let serverMsg = "using server: " + this._server;
                    // using extra line, otherwise remove logging screws up
                    console.log(serverMsg); /*RemoveLogging:skip*/
                    this.testServerPing();
                }
                else {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("server already set");
                    }
                    else {
                        
                    }
                }
            };
            /**
             * Gets the server (URL of the Service Layer) or NULL.
             * @returns the server (URL of the Service Layer) or NULL
             */
            this.getServer = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.getServer()");
                }
                else {
                    
                }
                return this._server;
            };
            /**
             * Tests the server with a basic ping an resets the valid server information.
             */
            this.testServerPing = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.testServerPing()");
                }
                else {
                    
                }
                this._validServer = null;
                this.Loader.genericServiceCall('/Config.svc/rest/basicping', this._receivePing, this._receivePingError, null, true);
            };
            /**
             * Waits until the Gateway version is set (and lets other code from the stack to be run).
             * @returns a Promise that resolves once the Gateway version is set
             */
            this.waitForVersionSet = () => __awaiter(this, void 0, void 0, function* () {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.waitForVersionSet()");
                }
                else {
                    
                }
                let counter = 0;
                while (!this._isVersionSet() && counter < WPTNamespace.MAX_SLEEP_INTERVALLS) {
                    counter++;
                    yield this.Functions.sleep(this._sleepTime);
                }
                if (counter >= WPTNamespace.MAX_SLEEP_INTERVALLS) {
                    console.warn("no version set during " + WPTNamespace.MAX_SLEEP_INTERVALLS + " intervals of waiting, hence aborted...");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("finished waiting for version set: " + counter);
                }
                else {
                    
                }
            });
            this.serviceAvailable = (serviceName) => {
                this._log.info("WPTCore.serviceAvailable");
                let kvp = this._serviceCapabilities.find(cap => (cap.Key == serviceName));
                if (kvp)
                    return (kvp.Value == 'true');
                else
                    return false;
            };
            /**
             * Informs WPT about finishing of initialisation of a module.
             * @param module module that has finished initialisation
             */
            this.moduleInitialisationFinished = (module) => {
                
                
                let initModule = this._initModules[module.Type];
                if (initModule != null && initModule != undefined) {
                    
                    delete this._initModules[module.Type];
                    this._initModulesCounter--;
                    
                    // special handling for finished modules
                    if (module.Type == WPTNamespace.CONFIG_TYPE) {
                        
                        let config = this.Config.getMainConfig();
                        if (config.hasOwnProperty('KeepAliveInterval') && config.KeepAliveInterval > 0) {
                            this._keepAliveInterval = config.KeepAliveInterval;
                        }
                        else {
                            this._keepAliveInterval = KEEPALIVE_INTERVAL;
                        }
                        if (config.hasOwnProperty('SleepTime') && config.SleepTime > 0) {
                            this._sleepTime = config.SleepTime;
                        }
                        
                        // Can inform locales module it can read config
                        this.Locale.setConfigurationReady();
                    }
                }
                // check if all modules are initialised and the "core" can move forward
                if (this._currentStage >= WPTStages.INITDONE && this._initModulesCounter == 0) {
                    
                    this._currentStage = WPTStages.READY;
                    
                    // when the version is set, final initialisation can happen
                    this.waitForVersionSet().then(this._finishInitialisation);
                }
            };
            this.logon = (username, password, callback, errorCallback, failCallBack) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.logon()");
                }
                else {
                    
                }
                this.Loader.basicAuthenticationCall(username, password, this._handleLogon.bind(this, callback), errorCallback, failCallBack);
            };
            this.logonIdP = (token, callback, errorCallback, failCallBack) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.logonIdP()");
                }
                else {
                    
                }
                this.Loader.idpAuthenticationCall(token, this._handleLogon.bind(this, callback), errorCallback, failCallBack);
            };
            this.logoff = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore.logoff()");
                }
                else {
                    
                }
                this.Loader.disconnectCall(this._handleLogoff, this._logoffError, this._logoffFailed);
            };
            this.getSleepTime = () => {
                return this._sleepTime;
            };
            this._handleLogon = (callback, data) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._handleLogon()");
                }
                else {
                    
                }
                this._setLoginValues(data);
                this.OBHelper.PreloadCache();
                callback();
            };
            /**
             * Sets the values from successful login response.
             * @param data the login response
             */
            this._setLoginValues = (data) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._setLoginValues()");
                }
                else {
                    
                }
                // set the values from login for later use
                this._currentLoginTime = new Date();
                this._currentConnection = data.Connection;
                this._currentConnectionId = data.Connection.ID;
                this._currentUser = data.User;
                this._currentUsername = data.User.Username;
                // check if user variables are provided and store them for later use
                if (data.hasOwnProperty('UserVariables')) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("setting user variables");
                    }
                    else {
                        
                    }
                    this._currentUserVariables = data.UserVariables;
                }
                else {
                    this._currentUserVariables = [];
                }
                this._applyUserVariables();
                if (data.hasOwnProperty('ServiceCapabilities') && (data.ServiceCapabilities != null))
                    this._serviceCapabilities = data.ServiceCapabilities;
                else
                    this._serviceCapabilities = [];
                // We may also have a user profile
                if (data.hasOwnProperty('Profile') && data.Profile) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("Received user profile at login");
                    }
                    else {
                        
                    }
                    this._currentUserProfile = data.Profile;
                    this._createUserProfileConfigVarsMap();
                }
                else {
                    this._currentUserProfile = null;
                }
                // activating keep alive
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("using keep alive interval: " + this._keepAliveInterval);
                }
                else {
                    
                }
                this._keepAliveIntervalId = window.setInterval(this._keepAlive, this._keepAliveInterval);
                // We might want to reload our theme
                this.Helper.requestTheme();
            };
            this._applyUserVariables = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._applyUserVariables()");
                }
                else {
                    
                }
                this._currentUserVariables.forEach(kvp => {
                    this.Context.setSessionVariable(kvp.Key, kvp.Value, true);
                });
            };
            /**
             * Handles successful logoff.
             */
            this._handleLogoff = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._handleLogoff()");
                }
                else {
                    
                }
                this._clearLoginValues();
                // Attempt IdP logoff - won't actually do anything if not using IdP
                let nav = this.Navigation.Logon;
                if (nav.UsingIdP) {
                    nav.idpLogout();
                    return;
                }
                // clears home and detail view to prevent data seen by unauthorised users
                this.Navigation.Details.resetNavigation();
                this.Navigation.Home.resetNavigation();
                // checks whether switching the application is needed after logoff
                let needsUpdate = this.Navigation.Menu.updateApplications(true);
                if (!needsUpdate) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("no update needed, hence switching to logon...");
                    }
                    else {
                        
                    }
                    this._reinitOnLogout();
                    this.Navigation.Menu.startLogonView();
                }
                else {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("update needed, hence NO switching to logon necessary");
                    }
                    else {
                        
                    }
                }
            };
            this._logoffError = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._logoffError()");
                }
                else {
                    
                }
                this.Helper.presentWarningModal("STR_WPT_LOGOFF_FAILED");
            };
            this._logoffFailed = (response) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._logoffFailed()");
                }
                else {
                    
                }
                let errorMsg = this.Locale.getTranslation("STR_WPT_LOGOFF_FAILED");
                if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message') && response.Connection.Message.length > 0) {
                    errorMsg += " " + this.Locale.getTranslation("STR_WPT_ERROR") + ": " + response.Connection.Message;
                }
                this.Helper.presentWarningModal(errorMsg);
            };
            /**
             * Clears the values after successful logoff.
             */
            this._clearLoginValues = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._clearLoginValues()");
                }
                else {
                    
                }
                // stop and clear keep alive
                window.clearInterval(this._keepAliveIntervalId);
                this._keepAliveIntervalId = null;
                // clearing the login values
                this._currentLoginTime = null;
                this._currentConnection = null;
                this._currentConnectionId = null;
                this._currentUser = null;
                this._currentUsername = null;
                this._currentUserProfile = null;
                this._currentUserVariables = [];
            };
            /**
             * Executes keep alive call.
             */
            this._keepAlive = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._keepAlive()");
                }
                else {
                    
                }
                // do call only if no other keep alive is running and an user is logged in
                if (!this._keepAliveRunning && this.isUserLoggedIn()) {
                    this._keepAliveRunning = true;
                    this.Navigation.Menu.showBottomHourGlass();
                    this.Loader.genericServiceCall('/Config.svc/rest/KeepAlive', this._keepAliveResponse, this._keepAliveError, this._keepAliveFailed);
                }
            };
            /**
             * Handle keep alive response.
             */
            this._keepAliveResponse = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._keepAliveResponse()");
                }
                else {
                    
                }
                this._keepAliveRunning = false;
                this.Navigation.Menu.hideBottomHourGlass();
            };
            this._keepAliveError = (url, status, text) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._keepAliveError()");
                }
                else {
                    
                }
                this._keepAliveRunning = false;
                this.Navigation.Menu.hideBottomHourGlass();
                let msgPrefix = this.Locale.getTranslation('STR_WPT_KEEPALIVE_ERROR_MSG');
                let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                this.Helper.presentWarningServiceModal("STR_WPT_KEEPALIVE", "STR_WPT_ERROR", msgBody, this._handleLogoff);
            };
            this._keepAliveFailed = (response) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._keepAliveFailed()");
                }
                else {
                    
                }
                this._keepAliveRunning = false;
                this.Navigation.Menu.hideBottomHourGlass();
                let msgBody = this.Locale.getTranslation('STR_WPT_KEEPALIVE_ERROR_MSG');
                if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message') && response.Connection.Message.length > 0) {
                    msgBody += ".\n\n" + this.Locale.getTranslation("STR_WPT_ERROR") + ": \n" + response.Connection.Message;
                }
                this.Helper.presentWarningServiceModal("STR_WPT_KEEPALIVE", "STR_WPT_ERROR", msgBody, this._handleLogoff);
            };
            /**
             * Error callback for loading version.json.
             * @param url URL used for the attempt to get version.json
             * @param status status code for the attempt to get version.json
             * @param statusText status text for the attempt to get version.json
             */
            this._noVersionData = (url, status, statusText) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._noVersionData()");
                }
                else {
                    
                }
                let msg = "failed to get version.json from '" + url + "': " + status + " - " + statusText;
                console.error(msg);
                // using alert, since basic functionality is not given
                alert(msg);
            };
            /**
             * Determines if the version from version.json is loaded.
             * @returns 'true' when the Gateway version is set, otherwise 'false'
             */
            this._isVersionSet = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._isVersionSet()");
                }
                else {
                    
                }
                return this._version != null;
            };
            /**
             * Initialises the remaining core "modules".
             */
            this._init = () => {
                
                // start initialisation of the core "modules"
                this.Logging = new WPTNamespace.LogManager(this);
                this._initModules[this.Logging.Type] = this.Logging;
                this._initModulesCounter++;
                this.Locale = new WPTNamespace.LocaleManager(this);
                this._initModules[this.Locale.Type] = this.Locale;
                this._initModulesCounter++;
                this.Config = new WPTNamespace.ConfigManager(this);
                this._initModules[this.Config.Type] = this.Config;
                this._initModulesCounter++;
                // setting the stage
                this._currentStage = WPTStages.INITDONE;
                
                
            };
            /**
             * Initialises the remaining "modules", dependent on core "modules".
             */
            this._finishInitialisation = () => {
                this._log = this.Logging.getLogger(LOG_CATEGORY);
                if (this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._finishInitialisation()");
                }
                this.Functions.initLogging(this);
                this.Loader.initLogging();
                this.Locale.initLogging();
                this.Config.initLogging();
                if (this.Helper == null) {
                    this.Helper = new WPTNamespace.Utilities.HelperFunctions(this);
                }
                else {
                    this.Helper.init();
                }
                if (this.OBHelper == null) {
                    this.OBHelper = new WPTNamespace.Utilities.OnBaseHelper(this);
                }
                else {
                    this.OBHelper.init();
                }
                if (this.Widgets == null) {
                    this.Widgets = new WPTNamespace.Widgets.WidgetManager(this);
                }
                if (this.Navigation == null) {
                    this.Navigation = new WPTNamespace.Navigation.NavigationManager(this);
                }
                else {
                    this.Navigation.init();
                }
                if (this.Context == null) {
                    this.Context = new WPTNamespace.Utilities.ApplicationContext(this);
                }
                else {
                    this.Context.init();
                }
                if (this.DocumentActions == null) {
                    this.DocumentActions = new WPTNamespace.DocActions.DocActionManager(this);
                }
                else {
                    this.DocumentActions.init();
                }
                // need to "reapply" UserVariables after application switch
                if (this.isUserLoggedIn()) {
                    this._applyUserVariables();
                }
            };
            /**
             * Reinitialises some "modules" after logout.
             */
            this._reinitOnLogout = () => {
                this._log.info("WPTCore._reinitOnLogout()");
                this.OBHelper.init();
                this.Context.init();
                this.DocumentActions.init();
            };
            /**
             * Sets the version of the gateway.
             * @param versionData data from version.json
             */
            this._setGatewayVersion = (versionData) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._setGatewayVersion()");
                }
                else {
                    
                }
                let release = versionData.Release;
                if (release == null || release == undefined || release.length <= 0) {
                    let msg = "failed to read release from version.json";
                    console.error(msg);
                    // using alert, since basic functionality is not given
                    alert(msg);
                }
                else {
                    this._version = release;
                    let versionMsg = "running WPT Gateway version: " + this._version + " (2.4.0.0-20220822_041044)";
                    // using extra line, otherwise remove logging screws up
                    console.log(versionMsg); /*RemoveLogging:skip*/
                }
            };
            /**
             * Handles the response for the basic ping test of the server.
             * @param pingResponse the response from the server
             */
            this._receivePing = (pingResponse) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._receivePing()");
                }
                else {
                    
                }
                this._validServer = pingResponse.Connection.ValidServer.toString();
            };
            /**
             * Handles the error case for the basic ping test of the server.
             * @param url URL used for the attempt to do basic ping test
             * @param status status code for the attempt to do basic ping test
             * @param statusText status text for the attempt to do basic ping test
             */
            this._receivePingError = (url, status, statusText) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._receivePingError()");
                }
                else {
                    
                }
                console.warn("failed to get basic ping from '" + url + "': " + status + " - " + statusText);
                this._validServer = "false";
                // if helper is already available show a warning message
                if (this.Helper != null) {
                    this.Helper.presentWarningModal("STR_WPT_UNABLELOCSERV");
                }
            };
            /**
             * Function called before the page is unloaded and shows confirmation dialog if necessary.
             * @param event event triggered before unload of the page happens
             */
            this._beforeUnloadWPT = (event) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._beforeUnloadWPT()");
                }
                else {
                    
                }
                if (this.isUserLoggedIn()) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("a user is logged in, hence showing confirmation message before unload");
                    }
                    else {
                        
                    }
                    event.preventDefault(); // HTML specification
                    let confirmationMessage = 'You have an open connection please log off.';
                    (event || window.event).returnValue = confirmationMessage; // Gecko + IE
                    return confirmationMessage; // Gecko + Webkit, Safari, Chrome etc.
                }
                else {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("no user logged in, hence nothing to do");
                    }
                    else {
                        
                    }
                }
            };
            /**
             * Function called during the page is unloaded and disconnects the session if necessary.
             * @param event event triggered during unload of the page happens
             */
            this._unloadWPT = (event) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("WPTCore._unloadWPT()");
                }
                else {
                    
                }
                // check for connectionId and do disconnect call
                if (this._currentConnectionId != null) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("a connection is open, hence doing disconnect call");
                    }
                    else {
                        
                    }
                    // using Beacon API since AJAX calls are now blocked by most browsers during unload
                    let url = this.getServer() + '/Config.svc/rest/SimpleDisconnect';
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("sending beacon to: " + url);
                    }
                    else {
                        
                    }
                    // queues the disconnect call and is not blocking the UI for the user
                    let result = navigator.sendBeacon(url, this._currentConnectionId);
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("beacon queued successfully? " + result);
                    }
                    else {
                        
                    }
                }
                else {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("no connection, hence nothing to do");
                    }
                    else {
                        
                    }
                }
            };
            this._createUserProfileConfigVarsMap = () => {
                if (this._log)
                    this._log.info('WPTCore.GetUserProfileConfigVar');
                if (!this.serviceAvailable('userprofiles') || !this._currentUserProfile)
                    return;
                // We have a profile - set default
                this._currentUserProfile.ConfigVarsMap = {};
                if (!this._currentUserProfile.hasOwnProperty('ConfigVariables') || !this._currentUserProfile.ConfigVariables)
                    return;
                this._currentUserProfile.ConfigVariables.forEach(kvp => {
                    if (kvp.Key && kvp.Value) {
                        this._currentUserProfile.ConfigVarsMap[kvp.Key] = kvp.Value;
                        this._currentUserProfile.ConfigVarsMap[kvp.Key.toUpperCase()] = kvp.Value;
                    }
                });
            };
            this.GetUserProfileConfigVar = (key) => {
                if (this._log) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`WPTCore.GetUserProfileConfigVar -> '${key}'`);
                    }
                    else
                        this._log.info('WPTCore.GetUserProfileConfigVar');
                }
                if (!this.serviceAvailable('userprofiles') || !this._currentUserProfile)
                    return null;
                if (Object.keys(this._currentUserProfile.ConfigVarsMap).indexOf(key) > -1)
                    return this._currentUserProfile.ConfigVarsMap[key];
                if (Object.keys(this._currentUserProfile.ConfigVarsMap).indexOf(key.toUpperCase()) > -1)
                    return this._currentUserProfile.ConfigVarsMap[key.toUpperCase()];
                if (this._log.isTraceEnabled()) {
                    this._log.trace('WPTCore.GetUserProfileConfigVar -> variable not set.');
                }
                return null;
            };
            this.SetUserProfileConfigVar = (key, value, callback = null) => {
                if (this._log)
                    this._log.info('WPTCore.SetUserProfileConfigVar');
                if (!this.serviceAvailable('userprofiles') || !this._currentUserProfile) {
                    if (callback)
                        callback(false);
                    return;
                }
                // TODO: Check case sensitivity here.
                if (Object.keys(this._currentUserProfile.ConfigVariables).indexOf(key) > -1) {
                    // Already set to passed variable, do nothing but announce we are good
                    if (this._currentUserProfile.ConfigVarsMap[key] == value) {
                        if (callback)
                            callback(true);
                        return;
                    }
                }
                // If we are here, the key is new or the value has changed
                // For asynchronicity protection, set here byt will be reset on finalising the call to set in OnBase
                if (value) {
                    this._currentUserProfile.ConfigVarsMap[key] = value;
                    this._currentUserProfile.ConfigVarsMap[key.toUpperCase()] = value;
                }
                else {
                    delete this._currentUserProfile.ConfigVarsMap[key];
                    delete this._currentUserProfile.ConfigVarsMap[key.toUpperCase()];
                }
                // Set up the payload and call
                let request = {
                    Name: key,
                    Value: value
                };
                this.Loader.genericServiceCallWithData('/User.svc/rest/SetUserProfileSetting', JSON.stringify(request), this._userProfileConfigVarsSet.bind(this, callback), {}, this._userProfileConfigVarsSetError.bind(this, callback), this._userProfileConfigVarsSetFail.bind(this, callback));
            };
            this._userProfileConfigVarsSet = (callback, response) => {
                if (this._log)
                    this._log.info('WPTCore._userProfileConfigVarsSet');
                if (response.hasOwnProperty('Settings') && response.Settings) {
                    this._currentUserProfile.ConfigVariables = response.Settings;
                    this._createUserProfileConfigVarsMap();
                }
                else {
                    this._currentUserProfile.ConfigVariables = [];
                    this._currentUserProfile.ConfigVarsMap = {};
                }
                if (callback)
                    callback(true);
            };
            this._userProfileConfigVarsSetError = (callback, url, status, statusText) => {
                if (this._log)
                    this._log.info('WPTCore._userProfileConfigVarsSetError');
                // Need to rebind the callback as we can't send a function with a parameter
                this.Helper.presentWarningServiceModal("STR_WPT_SETUSERSETTING", "STR_WPT_ERROR", `${statusText} (${status})`, this._userProfileConfigVarsSetErrorCallback.bind(this, callback));
            };
            this._userProfileConfigVarsSetFail = (callback, json) => {
                if (this._log)
                    this._log.info('WPTCore._userProfileConfigVarsSetFail');
                let error = "An error occurred attempting to set a user setting against the user's profile.";
                if (json.hasOwnProperty('Connection') && json.Connection.hasOwnProperty('Error') && json.Connection.Error && json.Connection.hasOwnProperty('Message')) {
                    error = json.Connection.Message;
                }
                // Need to rebind the callback as we can't send a function with a parameter
                this.Helper.presentWarningServiceModal("STR_WPT_SETUSERSETTING", "STR_WPT_ERROR", error, this._userProfileConfigVarsSetErrorCallback.bind(this, callback));
            };
            this._userProfileConfigVarsSetErrorCallback = (callback) => {
                if (this._log)
                    this._log.info('WPTCore._userProfileConfigVarsSetFail');
                if (callback)
                    callback(false);
            };
            
            this._currentStage = WPTStages.INIT;
            // register handling of unloading the page
            window.addEventListener("beforeunload", this._beforeUnloadWPT);
            window.addEventListener("pagehide", this._unloadWPT);
            // create the modals
            let modal1 = document.getElementById('modalPlaceholder');
            this._freeModals[ModalType[ModalType.FIRST]] = {
                Type: ModalType.FIRST,
                DIV: modal1,
                JQ: $(modal1)
            };
            let modal2 = document.getElementById('secondModalPlaceholder');
            this._freeModals[ModalType[ModalType.SECOND]] = {
                Type: ModalType.SECOND,
                DIV: modal2,
                JQ: $(modal2)
            };
            let errorModal = document.getElementById('errorModalPlaceholder');
            this._freeModals[ModalType[ModalType.ERROR]] = {
                Type: ModalType.ERROR,
                DIV: errorModal,
                JQ: $(errorModal)
            };
            // initialise the first "core modules" (mostly "static" functions, no dependencies to other modules)
            this.Functions = new WPTNamespace.Utilities.GenericFunctions();
            this.Loader = new WPTNamespace.LoaderManager(this);
            // getting the version
            this.Loader.getUnversionedJSON('version.json', this._setGatewayVersion, this._noVersionData);
            // initialise remaining "modules"
            this._init();
        }
        /**
         * Gets all the query string for iteration - used by the custom filter management code
         */
        get QueryStringValues() {
            if (this._log !== null && this._log.isInfoEnabled()) {
                this._log.info("WPTCore.QueryStringValues()");
            }
            else {
                
            }
            if (this._queryString == null)
                return [];
            else
                return this._queryString;
        }
        get CurrentUserProfile() {
            if (this._log !== null && this._log.isInfoEnabled()) {
                this._log.info("WPTCore.CurrentUserProfile()");
            }
            else {
                
            }
            return this._currentUserProfile;
        }
        get UserProfile() {
            return this._currentUserProfile;
        }
    }
    WPTNamespace.WPTCore = WPTCore;
})(WPTNamespace || (WPTNamespace = {}));
